"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = exports.isSlug = void 0;
function isSlug(slug) {
    return /^[a-z\d]+(?:-[a-z\d]+)*$/.test(slug);
}
exports.isSlug = isSlug;
const NON_LATIN = [
    ['à', 'a'],
    ['á', 'a'],
    ['â', 'a'],
    ['ã', 'a'],
    ['ä', 'a'],
    ['ä', 'a'],
    ['å', 'a'],
    ['ā', 'a'],
    ['ą', 'a'],
    ['ă', 'a'],
    ['æ', 'ae'],
    ['ç', 'c'],
    ['ć', 'c'],
    ['č', 'c'],
    ['ĉ', 'c'],
    ['ċ', 'c'],
    ['ď', 'd'],
    ['đ', 'd'],
    ['ð', 'd'],
    ['è', 'e'],
    ['é', 'e'],
    ['ê', 'e'],
    ['ë', 'e'],
    ['ē', 'e'],
    ['ę', 'e'],
    ['ě', 'e'],
    ['ĕ', 'e'],
    ['ė', 'e'],
    ['ƒ', 'f'],
    ['ĝ', 'g'],
    ['ğ', 'g'],
    ['ġ', 'g'],
    ['ģ', 'g'],
    ['ĥ', 'h'],
    ['ħ', 'h'],
    ['ì', 'i'],
    ['í', 'i'],
    ['î', 'i'],
    ['ï', 'i'],
    ['ī', 'i'],
    ['ĩ', 'i'],
    ['ĭ', 'i'],
    ['į', 'i'],
    ['ı', 'i'],
    ['ĳ', 'ij'],
    ['ĵ', 'j'],
    ['ķ', 'k'],
    ['ĸ', 'k'],
    ['ł', 'l'],
    ['ľ', 'l'],
    ['ĺ', 'l'],
    ['ļ', 'l'],
    ['ŀ', 'l'],
    ['ñ', 'n'],
    ['ń', 'n'],
    ['ň', 'n'],
    ['ņ', 'n'],
    ['ŉ', 'n'],
    ['ŋ', 'n'],
    ['ò', 'o'],
    ['ó', 'o'],
    ['ô', 'o'],
    ['õ', 'o'],
    ['ö', 'o'],
    ['ö', 'o'],
    ['ø', 'o'],
    ['ō', 'o'],
    ['ő', 'o'],
    ['ŏ', 'o'],
    ['œ', 'oe'],
    ['ŕ', 'r'],
    ['ř', 'r'],
    ['ŗ', 'r'],
    ['š', 's'],
    ['ù', 'u'],
    ['ú', 'u'],
    ['û', 'u'],
    ['ü', 'u'],
    ['ū', 'u'],
    ['ü', 'u'],
    ['ů', 'u'],
    ['ű', 'u'],
    ['ŭ', 'u'],
    ['ũ', 'u'],
    ['ų', 'u'],
    ['ŵ', 'w'],
    ['ý', 'y'],
    ['ÿ', 'y'],
    ['ŷ', 'y'],
    ['ž', 'z'],
    ['ż', 'z'],
    ['ź', 'z'],
    ['þ', 't'],
    ['ß', 'ss'],
    ['ſ', 'ss'],
    ['ый', 'iy'],
    ['а', 'a'],
    ['б', 'b'],
    ['в', 'v'],
    ['г', 'g'],
    ['д', 'd'],
    ['е', 'e'],
    ['ё', 'yo'],
    ['ж', 'zh'],
    ['з', 'z'],
    ['и', 'i'],
    ['й', 'y'],
    ['к', 'k'],
    ['л', 'l'],
    ['м', 'm'],
    ['н', 'n'],
    ['о', 'o'],
    ['п', 'p'],
    ['р', 'r'],
    ['с', 's'],
    ['т', 't'],
    ['у', 'u'],
    ['ф', 'f'],
    ['х', 'h'],
    ['ц', 'c'],
    ['ч', 'ch'],
    ['ш', 'sh'],
    ['щ', 'sch'],
    ['ъ', ''],
    ['ы', 'y'],
    ['ь', ''],
    ['э', 'e'],
    ['ю', 'yu'],
    ['я', 'ya'],
];
function slugify(text) {
    if (!text) {
        return '';
    }
    // NOTICE: currently no coverage of non-latin to latin char conversion
    let slug = text.trim().toLowerCase()
        .replace(/\s+/g, '-');
    NON_LATIN.forEach((latin) => {
        const re = new RegExp(latin[0], 'g');
        slug = slug.replace(re, latin[1]);
    });
    slug = slug.replace(/[^a-z\d-]/g, '');
    // replace multiple - with single -
    slug = slug.replace(/--+/g, '-');
    // One final test, just in case
    if (!isSlug(slug)) {
        throw new Error(`Error occurred when creating slug from text ${text}`);
    }
    return slug;
}
exports.slugify = slugify;
